<lib-gestion-des-salaries [configuration]="configuration" [declarationSinistre]="configuration.declaration"
                          [isV2]="configuration.IS_GESTION_SALARIE_V2"
                          (onAddViaDsnEvent)="handleOnAddViaDsnEvent($event)"
                          [fileNamePattern]="fileNamePattern"
                          [showTransfer]="configuration.showTransfer"></lib-gestion-des-salaries>
